import Vue from 'vue';
import VueFileUpload from 'vue-file-upload';
import cookie from '../../cookie/cookie';
import templateUpdateTips from '../console-common/template-update-tips.vue';
export default Vue.extend({
    name: 'batchImport',
    components: {
        VueFileUpload: VueFileUpload,
        'el-template-update-tips': templateUpdateTips,
    },
    props: {
        type: {
            type: String,
            default: '',
            required: true,
        },
        uploadUrl: {
            type: String,
            default: '',
            required: true,
        },
    },
    data: function () {
        return {
            showChangeFileBtn: true,
            fileName: '',
            changeBtnName: '取消',
            uploadStatus: '',
            percentage: 0,
            chageProcessBgColor: false,
            usernameZh: '',
            popoverVisible: false,
            loadingMain: null,
        };
    },
    created: function () {
        this.getUserName();
    },
    computed: {
        importText: function () {
            return this.type === 'contract' ? '合同信息' : '还款计划信息';
        },
        importPath: function () {
            return this.type === 'contract'
                ? '合同管理-合同查询'
                : '还款计划管理-还款计划查询';
        },
        importUrl: function () {
            return this.type === 'contract'
                ? '/console/contract/query'
                : '/console/repayment-plan/query-list';
        },
        btnQueryText: function () {
            return this.type === 'contract' ? '合同查询' : '还款计划查询';
        },
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
            // this.merchantId = cookie.getCookie('merchantId')
        },
        beforeAvatarUpload: function (file) {
            var fileArr = file.name.split('.');
            var name = fileArr[fileArr.length - 1];
            var reg = /^xlsx|xls$/;
            if (!reg.test(name)) {
                this.$confirm('', '', {
                    message: '<p class="title">仅支持xlsx或xls格式文件</p>',
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '知道了',
                    showClose: false,
                    type: 'error',
                    showCancelButton: false,
                });
                return false;
            }
        },
        customRequest: function (_a) {
            var file = _a.file;
            this.file = file;
            this.showChangeFileBtn = false;
            this.fileName = file.name;
            this.percentage = 100;
            this.uploadStatus = '上传完成';
            this.changeBtnName = '删除';
        },
        uploadError: function () {
            this.chageProcessBgColor = true;
            this.uploadStatus = '上传失败，请重试';
            this.changeBtnName = '重新上传';
        },
        batchImport: function () {
            var _this = this;
            var url = this.type === 'contract'
                ? '/batch/contract/import'
                : '/batch/plan/import';
            this.loadingMain = Vue.prototype.$loading({
                spinner: 'el-icon-loading',
                background: 'rgba(300, 300, 300, 0.5)',
                customClass: 'loading',
                body: true,
            });
            this.$request({
                method: 'post',
                url: "/proxy/file/" + url,
                data: {
                    file: this.file,
                    // tenant: this.merchantId,
                    creator: this.usernameZh,
                },
                loadingControl: 'hand',
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                transformRequest: function (data) {
                    var formData = new FormData();
                    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
                        var key = _a[_i];
                        if (data[key] != null) {
                            formData.append(key, data[key]);
                        }
                    }
                    return formData;
                },
            }).then(function (res) {
                if (!res) {
                    return _this.loadingMain.close();
                }
                if (!res.errorCode) {
                    var key = res.data;
                    _this.realGetImportPro(key);
                }
                else {
                    return _this.loadingMain.close();
                }
            });
        },
        getImportPro: function (key) {
            return this.$request({
                method: 'post',
                url: "/proxy/api/batch/import/progress",
                data: {
                    uploadKey: key,
                },
                loadingControl: 'hand',
            });
        },
        realGetImportPro: function (key) {
            var _this = this;
            var timer = null;
            var pollingMain = function () {
                _this.getImportPro(key).then(function (res) {
                    if (!res || res.errorCode) {
                        clearTimeout(timer);
                        _this.$confirm('', '', {
                            message: "<p class=\"title\">\u6279\u91CF\u5BFC\u5165\u51FA\u9519\u4E86</p><p class=\"text\">" + res.errorMsg + "</p>",
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '知道了',
                            type: 'error',
                            showClose: false,
                        }).then(function () {
                            _this.showChangeFileBtn = true;
                            _this.changeBtnName = '取消';
                        });
                        return _this.loadingMain.close();
                    }
                    if (!res.errorCode && res.data.finished) {
                        clearTimeout(timer);
                        if (!res.errorCode && res.data.total > res.data.success) {
                            _this.$confirm('', '', {
                                message: "<p class=\"title\">\u6279\u91CF\u5BFC\u5165\u5B8C\u6210\uFF0C" + res.data.failure + "\u6761\u5BFC\u5165\u5931\u8D25</p><p class=\"text\">\u6210\u529F\u5BFC\u5165" + res.data.success + "\u6761" + _this.importText + "\uFF0C" + res.data.failure + "\u6761\u5BFC\u5165\u5931\u8D25\uFF0C\u8BF7\u4E0B\u8F7D\u6709\u8BEF\u7684\u4FE1\u606F\uFF0C\u4FEE\u6539\u540E\u91CD\u65B0\u5BFC\u5165</p>",
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: '下载信息',
                                cancelButtonText: '取消',
                                type: 'warning',
                                showClose: false,
                            }).then(function () {
                                _this.showChangeFileBtn = true;
                                _this.changeBtnName = '取消';
                                window.open(res.data.url);
                            });
                        }
                        if (!res.errorCode && res.data.total === res.data.success) {
                            _this.$confirm('', '', {
                                message: "<p class=\"title\">\u5DF2\u6210\u529F\u5BFC\u5165" + res.data.total + "\u6761" + _this.importText + "</p><p class=\"text\">\u53EF\u524D\u5F80" + _this.importPath + "\u67E5\u770B</p>",
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: _this.btnQueryText,
                                cancelButtonText: '好的',
                                type: 'warning',
                                showClose: false,
                            })
                                .then(function () {
                                _this.$router.push({
                                    path: _this.importUrl,
                                });
                            })
                                .catch(function () {
                                _this.showChangeFileBtn = true;
                                _this.changeBtnName = '取消';
                            });
                        }
                        return _this.loadingMain.close();
                    }
                    timer = setTimeout(function () {
                        pollingMain();
                    }, 1000);
                });
            };
            pollingMain();
        },
        canncelUploadFile: function () {
            var _this = this;
            if (this.changeBtnName === '重新上传') {
                this.percentage = 0;
            }
            else if (this.changeBtnName === '删除') {
                this.$confirm('', '', {
                    message: '<p class="title">您确定要删除这个文件吗？</p>',
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning',
                    showClose: false,
                })
                    .then(function () {
                    _this.showChangeFileBtn = true;
                    _this.changeBtnName = '取消';
                })
                    .catch(function () {
                    // this.percentage = 100
                });
            }
            else {
                this.percentage = 0;
                this.showChangeFileBtn = true;
                this.changeBtnName = '取消';
            }
        },
        closePopover: function () {
            this.popoverVisible = false;
        },
    },
});
